import React, { useEffect, useState } from "react"
import { GroupPriceRow } from "./GroupPriceRow"
import { buildGroups, GroupModel } from "../../../models/organisation/GroupModel"
import { BidModel } from "../../../models/bid/BidModel"
import { colorPrimaryDark } from "../../../rsc/colors/colors"
import { Loader } from "../../../components/Loader"
import { client } from "../../.."
import { getGroupListForOrg } from "../../../api"
import { isArrayNullOrEmpty, showErrorMessage } from "../../../helper/helper"

type Props = {
    orgId: number
    basePrice: BidModel
}

export function GroupPriceSection({ orgId, basePrice }: Props) {

    const [groups, setGroups] = useState<GroupModel[]>(undefined)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (isArrayNullOrEmpty(groups)) {
            setLoading(true)
            client.query({
                query: getGroupListForOrg,
                variables: {
                    organisationId: orgId
                }
            }).then((data) => {
                let groups = buildGroups(data.data.groups)
                setGroups(groups)
            }).catch(e => {
                showErrorMessage(e)
            }).finally(() => {
                setLoading(false)
            })
        }
        // eslint-disable-next-line
    }, [])

    return <div style={{ display: !isArrayNullOrEmpty(groups) ? 'block' : 'none' }}>
        <p className='lightGreyBgColor padding10 marginBottom8 bold font-xnormal'>Group Price</p>
        <div className='bold' style={{ display: "flex", alignItems: "center", paddingLeft: "10px", gap: '10px', marginBottom: '10px', color: colorPrimaryDark }}>
            <div style={{ flex: 1, display: "flex" }}>
                Name
            </div>
            <div style={{ flex: 1, justifyContent: "end", display: "flex" }}>
                Bonus
            </div>
            <div style={{ flex: 1, justifyContent: "end", display: "flex" }}>
                Total
            </div>
            <div style={{ width: "100px" }} />
        </div>
        {groups?.map(g => {
            return <GroupPriceRow key={g.id} group={g} price={basePrice} />
        })
        }
        <Loader isLoading={loading} fullScreen={false} />

    </div>
}